import { ReactNode } from "react";
import { DotLegalAlert } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation";

interface RiskGovernanceViewBannerProps {
    isAsOf: boolean;
    asOf: string | null;
    afterMitigation: boolean;
    // Snapshot-only trailing controls (return-to-today / view-in-history). Omitted for the static PDF banner.
    action?: ReactNode;
    marginBottom?: number;
}

// The info banner shown when the overview is not on its current, live state: a point-in-time snapshot or the
// after-mitigation projection. Shared by the on-screen filter bar and the PDF so both explain the same view.
function RiskGovernanceViewBanner({ isAsOf, asOf, afterMitigation, action, marginBottom = 2 }: RiskGovernanceViewBannerProps) {
    const { translateString, translateDate } = useTranslation();

    if (isAsOf && asOf) {
        return (
            <DotLegalAlert
                severity="info"
                marginBottom={marginBottom}
                warningHeader={translateString("riskGovernanceSnapshotBannerTitle", { date: translateDate(new Date(asOf)) })}
                warningText={translateString("riskGovernanceSnapshotBannerText", { date: translateDate(new Date(asOf)) })}
                action={action}
            />
        );
    }

    if (afterMitigation && !isAsOf) {
        return (
            <DotLegalAlert
                severity="info"
                marginBottom={marginBottom}
                warningHeader={translateString("riskGovernanceAfterMitigationBannerTitle")}
                warningText={translateString("riskGovernanceAfterMitigationBannerText")}
            />
        );
    }

    return null;
}

export default RiskGovernanceViewBanner;
